import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class Lib3Service {

  constructor() { }
}
